var mercadorRadius = 85445659.44705395;
var mercadorOffset = 268435456;

function longitudeToPixelSpaceX(longitude) {
    return Math.round(mercadorOffset + (mercadorRadius * longitude * Math.PI) / 180.0);
}
function latitudeToPixelSpaceY(latitude) {
    return Math.round(
        mercadorOffset - (mercadorRadius * Math.log((1 + Math.sin((latitude * Math.PI) / 180.0)) / (1 - Math.sin((latitude * Math.PI) / 180.0)))) / 2.0
    );
}
function pixelSpaceXToLongitude(pixelX) {
    return (((Math.round(pixelX) - mercadorOffset) / mercadorRadius) * 180.0) / Math.PI;
}
function pixelSpaceYToLatitude(pixelY) {
    return ((Math.PI / 2.0 - 2.0 * Math.atan(Math.exp((Math.round(pixelY) - mercadorOffset) / mercadorRadius))) * 180.0) / Math.PI;
}
/**
 *
 * @param {object} map
 * @param {object} centerCoordinates
 * @param {number} zoomLevel
 */
function deltaFromZoomLevel(map, centerCoordinates, zoomLevel) {
    // convert center coordiate to pixel space
    var centerPixelX = longitudeToPixelSpaceX(centerCoordinates.longitude);
    var centerPixelY = latitudeToPixelSpaceY(centerCoordinates.latitude);
    // determine the scale value from the zoom level
    var zoomExponent = 20 - zoomLevel;
    var zoomScale = Math.pow(2, zoomExponent);
    // scale the map’s size in pixel space
    var mapSizeInPixels = map.visibleMapRect.size;
    var scaledMapWidth = mapSizeInPixels.width * zoomScale;
    var scaledMapHeight = mapSizeInPixels.height * zoomScale;
    // figure out the position of the top-left pixel
    var topLeftPixelX = centerPixelX - scaledMapWidth / 2;
    var topLeftPixelY = centerPixelY - scaledMapHeight / 2;
    // find delta between left and right longitudes
    var minLng = pixelSpaceXToLongitude(topLeftPixelX);
    var maxLng = pixelSpaceXToLongitude(topLeftPixelX + scaledMapWidth);
    var longitudeDelta = maxLng - minLng;
    // find delta between top and bottom latitudes
    var minLat = pixelSpaceYToLatitude(topLeftPixelY);
    var maxLat = pixelSpaceYToLatitude(topLeftPixelY + scaledMapHeight);
    var latitudeDelta = -1 * (maxLat - minLat);
    // create and return the lat/lng span
    return {
        latitudeDelta: latitudeDelta,
        longitudeDelta: longitudeDelta
    };
}
